export enum KtuinProductType {
  IPHONE = 'iPhone',
  IPAD = 'iPad',
  MAC = 'Mac',
  APPLE_WATCH = 'Apple Watch',
  AIRPODS = 'AirPods',
  OTHERS = 'Otros',
}
